import styled from 'styled-components';

export default styled.label`
    display: block;
    position: relative;
    padding-left: 30px;
    max-width: 300px;
    margin: auto;

    &::after {
        display: inline-block;
        position: absolute;
        left: 0;
        top: 0;
        content: ' ';
    }
`;
